export default "__VITE_ASSET__K_zLrpSj__"